module.exports = __webpack_public_path__ + "static/media/quinn.f599f9b3.jpg";